/* PSC Display v6 — animations et petites fonctions (sans dépendance) */
(function () {
  if (window.__pscFx) return;
  window.__pscFx = true;
  var doc = document.documentElement;
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var finePointer = window.matchMedia('(hover: hover) and (pointer: fine)').matches;
  var cfg = window.PSC_FX || {};
  var DELAY_MIN = Number(cfg.delayMin || 30);
  var DELAY_MAX = Number(cfg.delayMax || 50);

  function onReady(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }

  /* 1. Apparition au défilement : repli pour Safari / Firefox (pas de animation-timeline) */
  function setupReveal() {
    var supportsTimeline = window.CSS && CSS.supports && CSS.supports('animation-timeline: view()');
    if (supportsTimeline || reduce || !('IntersectionObserver' in window)) { doc.classList.remove('psc-io'); return; }
    doc.classList.add('psc-io');
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) {
          e.target.classList.add('is-in');
          io.unobserve(e.target);
        }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
    function watch(scope) {
      (scope || document).querySelectorAll('.psc-reveal:not(.is-in)').forEach(function (el) {
        if (el.dataset.pscWatched) return;
        el.dataset.pscWatched = '1';
        var parent = el.parentElement;
        if (parent) {
          var sibs = Array.prototype.filter.call(parent.children, function (c) { return c.classList && c.classList.contains('psc-reveal'); });
          var i = sibs.indexOf(el);
          if (i > 0) el.style.setProperty('--psc-d', Math.min(i, 6) * 70 + 'ms');
        }
        io.observe(el);
      });
    }
    watch();
    var pending = false;
    new MutationObserver(function () {
      if (pending) return;
      pending = true;
      requestAnimationFrame(function () { pending = false; watch(); });
    }).observe(document.body, { childList: true, subtree: true });
  }

  /* 2. En-tête : fond flouté dès qu'on défile ; bouton retour en haut */
  function setupHeader() {
    var header = document.querySelector('[data-psc-header]');
    var top = document.querySelector('[data-psc-totop]');
    var ticking = false;
    function update() {
      var y = window.scrollY || window.pageYOffset;
      if (header) header.classList.toggle('is-scrolled', y > 24);
      if (top) top.classList.toggle('is-on', y > 900);
      ticking = false;
    }
    window.addEventListener('scroll', function () {
      if (!ticking) { ticking = true; requestAnimationFrame(update); }
    }, { passive: true });
    update();
  }

  /* 3. Bouton retour en haut */
  function setupToTop() {
    var b = document.createElement('button');
    b.type = 'button';
    b.className = 'psc-totop';
    b.setAttribute('data-psc-totop', '');
    b.setAttribute('aria-label', 'Revenir en haut de la page');
    b.innerHTML = '<svg aria-hidden="true" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round"><path d="M12 19V5M5 12l7-7 7 7"/></svg>';
    b.addEventListener('click', function () { window.scrollTo({ top: 0, behavior: reduce ? 'auto' : 'smooth' }); });
    document.body.appendChild(b);
  }

  /* 4. Cartes produit : léger relief 3D et reflet qui suit la souris */
  function setupTilt() {
    if (reduce || !finePointer) return;
    var active = null;
    function reset(c) {
      c.classList.remove('is-tilt');
      c.style.removeProperty('--psc-rx');
      c.style.removeProperty('--psc-ry');
    }
    document.addEventListener('pointermove', function (e) {
      var card = e.target.closest && e.target.closest('.psc-prod, .psc-choice');
      if (active && active !== card) reset(active);
      if (!card) { active = null; return; }
      active = card;
      var r = card.getBoundingClientRect();
      var x = (e.clientX - r.left) / r.width, y = (e.clientY - r.top) / r.height;
      card.style.setProperty('--psc-rx', ((0.5 - y) * 5).toFixed(2) + 'deg');
      card.style.setProperty('--psc-ry', ((x - 0.5) * 7).toFixed(2) + 'deg');
      card.style.setProperty('--psc-mx', (x * 100).toFixed(1) + '%');
      card.style.setProperty('--psc-my', (y * 100).toFixed(1) + '%');
      card.classList.add('is-tilt');
    }, { passive: true });
    document.documentElement.addEventListener('mouseleave', function () { if (active) reset(active); active = null; });
  }

  /* 5. Chiffres clés de l'accueil : compteur animé */
  function setupCounters() {
    var nums = document.querySelectorAll('.psc-stats b');
    if (!nums.length || reduce || !('IntersectionObserver' in window)) return;
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (!e.isIntersecting) return;
        io.unobserve(e.target);
        var el = e.target, txt = el.textContent.trim(), n = parseInt(txt, 10);
        if (!/^[0-9]+$/.test(txt) || n < 2) return;
        var t0 = performance.now(), dur = 1100;
        (function step(t) {
          var k = Math.min(1, Math.max(0, (t - t0) / dur)), eased = 1 - Math.pow(1 - k, 3);
          el.textContent = Math.round(n * eased);
          if (k < 1) requestAnimationFrame(step); else el.textContent = txt;
        })(t0);
      });
    }, { threshold: 0.6 });
    nums.forEach(function (b) { io.observe(b); });
  }

  /* 6. Fiche produit : livraison offerte + date de réception estimée */
  function setupDelivery() {
    var price = document.querySelector('[data-psc-pdp] .psx-price');
    if (!price || document.querySelector('.psx-eta')) return;
    var title = (document.querySelector('[data-psc-pdp] .psx-h1') || {}).textContent || '';
    var kind = (document.querySelector('[data-psc-pdp] .psc-eyebrow') || {}).textContent || '';
    if (/carte cadeau|suppl/i.test(kind + ' ' + title)) return;
    function add(d, days) { var x = new Date(d); x.setDate(x.getDate() + days); return x; }
    var f = new Intl.DateTimeFormat('fr-FR', { day: 'numeric', month: 'long' });
    var now = new Date();
    var box = document.createElement('div');
    box.className = 'psx-eta';
    box.innerHTML =
      '<span class="psx-eta__row"><svg aria-hidden="true" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><path d="M3 7h11v9H3zM14 10h4l3 3v3h-7"/><circle cx="7" cy="18" r="2"/><circle cx="17" cy="18" r="2"/></svg>' +
      '<span><b>Livraison offerte</b> en point relais partout en France</span></span>' +
      '<span class="psx-eta__row"><svg aria-hidden="true" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><rect x="3" y="5" width="18" height="16" rx="2"/><path d="M3 10h18M8 3v4M16 3v4"/></svg>' +
      '<span>Réception estimée entre le <b>' + f.format(add(now, DELAY_MIN)) + '</b> et le <b>' + f.format(add(now, DELAY_MAX)) + '</b></span></span>';
    price.insertAdjacentElement('afterend', box);
  }

  /* 7. Ancres internes : défilement doux qui tient compte de l'en-tête */
  function setupAnchors() {
    document.addEventListener('click', function (e) {
      var a = e.target.closest && e.target.closest('a[href^="#"]');
      if (!a || a.hasAttribute('data-psc-top')) return;
      var id = a.getAttribute('href');
      if (id.length < 2) return;
      var target;
      try { target = document.querySelector(id); } catch (err) { return; }
      if (!target) return;
      e.preventDefault();
      var header = document.querySelector('[data-psc-header]');
      var off = header ? header.getBoundingClientRect().height + 12 : 80;
      window.scrollTo({ top: target.getBoundingClientRect().top + window.pageYOffset - off, behavior: reduce ? 'auto' : 'smooth' });
      if (history.replaceState) history.replaceState(null, '', id);
    });
  }

  /* 8. Effet d'appui sur les boutons (retour tactile) */
  function setupPress() {
    document.addEventListener('pointerdown', function (e) {
      var b = e.target.closest && e.target.closest('.psc-btn, .psc-chip');
      if (!b) return;
      b.classList.add('is-press');
      var off = function () { b.classList.remove('is-press'); window.removeEventListener('pointerup', off); window.removeEventListener('pointercancel', off); };
      window.addEventListener('pointerup', off);
      window.addEventListener('pointercancel', off);
    }, { passive: true });
  }

  /* 9. Configurateur : choix du modèle en menu déroulant simple (pas de saisie, pas de clavier) */
  function setupModelDropdown() {
    var root = document.querySelector('[data-psc-finder]');
    if (!root) return;
    var combo = root.querySelector('[data-combo]');
    var input = root.querySelector('[data-combo-input]');
    var field = root.querySelector('.cfg2-combo__field');
    if (!combo || !input || !field) return;
    input.readOnly = true;
    input.setAttribute('inputmode', 'none');
    input.setAttribute('aria-haspopup', 'listbox');
    input.removeAttribute('aria-autocomplete');
    input.placeholder = 'Choisir un modèle';
    combo.classList.add('is-select');
    // Toucher le champ quand la liste est ouverte la referme.
    var wasOpen = false;
    combo.addEventListener('pointerdown', function (e) {
      if (!field.contains(e.target)) return;
      wasOpen = combo.classList.contains('is-open');
      if (wasOpen) e.preventDefault();
    }, true);
    combo.addEventListener('click', function (e) {
      if (!field.contains(e.target) || !wasOpen) return;
      wasOpen = false;
      e.stopPropagation();
      input.blur();
    }, true);
  }

  onReady(function () {
    try { setupReveal(); } catch (e) { doc.classList.remove('psc-io'); }
    try { setupToTop(); } catch (e) {}
    try { setupHeader(); } catch (e) {}
    try { setupTilt(); } catch (e) {}
    try { setupCounters(); } catch (e) {}
    try { setupDelivery(); } catch (e) {}
    try { setupAnchors(); } catch (e) {}
    try { setupPress(); } catch (e) {}
    try { setupModelDropdown(); } catch (e) {}
  });
})();